export default __webpack_public_path__ + "static/media/28.fb3ecf7f.jpeg";